import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LiveMapComponent} from './components/live-map.component';
import {MaterialModule} from 'src/app/shared/material/material.module';
import {MatHoverDirective} from 'src/app/shared/directives/mat-hover.directive';
import {LiveMapRoutingModule} from './live-map-routing.module';
import {CommonModule, DatePipe} from '@angular/common';
import {LiveMapLoaderComponent} from './components/ui-components/live-map-loader/live-map-loader.component';
import {ShortDateOrTimePipe} from '../../shared/formatting/short-date-or-time.pipe';
import {
  VehicleGroupFilterButtonComponent
} from './components/ui-components/filters/vehicle-group-filter-button/vehicle-group-filter-button.component';
import {
  StatusFilterButtonComponent
} from './components/ui-components/filters/status-filter-button/status-filter-button.component';
import {
  ObservationTypeGroupFilterButtonComponent
} from './components/ui-components/filters/observation-type-group-filter-button/observation-type-group-filter-button.component';
import {
  DateRangeFilterButtonComponent
} from './components/ui-components/filters/date-range-filter-button/date-range-filter-button.component';
import {
  IncludeOfflineFilterComponent
} from './components/ui-components/filters/include-offline-filter/include-offline-filter.component';
import {LiveAddressComponent} from './components/ui-components/live-address/live-address.component';
import {RightPanelButtonComponent} from './components/ui-components/right-panel-button/right-panel-button.component';
import {RouteComponent} from './components/ui-components/route/route.component';
import {DurationPipe} from '../../shared/formatting/duration.pipe';
import {DistancePipe} from '../../shared/formatting/distance.pipe';
import {WeightPipe} from '../../shared/formatting/weight.pipe';
import {SpreaderMassPipe} from '../../shared/formatting/spreader-mass.pipe';
import {SpreaderLiquidPipe} from '../../shared/formatting/spreader-liquid.pipe';
import {VolumePipe} from '../../shared/formatting/volume.pipe';
import {WhatsNewComponent} from './components/ui-components/whats-new/whats-new.component';
import {DateFilterDropdownComponent} from '../../shared/components/date-filter-dropdown/date-filter-dropdown.component';
import {FilterButtonComponent} from '../../shared/components/buttons/filter-button/filter-button.component';
import {FilterBarComponent} from '../../shared/components/filter-bar/filter-bar.component';
import {CardMenuItemComponent} from '../../shared/components/card-menu-item/card-menu-item.component';
import { MapPanelComponent } from '../../shared/components/map-viewer/map-panel/map-panel.component';
import { ImageViewerComponent } from '../../shared/components/image-viewer/image-viewer.component';
import { RouteAssignmentQueueComponent } from './components/ui-components/route-assignment-queue/route-assignment-queue.component';
import { StatusLayerSwitcherComponent } from '../../shared/components/status-layer-switcher/status-layer-switcher.component';
import { MapLayerSwitcherComponent } from '../../shared/components/map-layer-switcher/map-layer-switcher.component';
import { VideoPlayerComponent } from '../../shared/components/video-player/video-player.component';
import { LiveMapPanelComponent } from './components/left-panel/live-map-panel.component';
import { FormattingModule } from '../../shared/formatting/formatting.module';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
  declarations: [
    LiveMapComponent,
    MatHoverDirective,
    LiveMapLoaderComponent,
    LiveAddressComponent,
    VehicleGroupFilterButtonComponent,
    StatusFilterButtonComponent,
    ObservationTypeGroupFilterButtonComponent,
    DateRangeFilterButtonComponent,
    IncludeOfflineFilterComponent,
    RightPanelButtonComponent,
    RouteComponent,
  ],
  imports: [
    CommonModule,
    FormattingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    LiveMapRoutingModule,
    WhatsNewComponent,
    DateFilterDropdownComponent,
    FilterButtonComponent,
    FilterBarComponent,
    CardMenuItemComponent,
    MapPanelComponent,
    ImageViewerComponent,
    RouteAssignmentQueueComponent,
    StatusLayerSwitcherComponent,
    MapLayerSwitcherComponent,
    VideoPlayerComponent,
    LiveMapPanelComponent,
    MatMomentDateModule,
  ],
  providers: [
    DatePipe,
    ShortDateOrTimePipe,
    DurationPipe,
    DistancePipe,
    WeightPipe,
    VolumePipe,
    SpreaderMassPipe,
    SpreaderLiquidPipe,
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  ],
  exports: [],
})
export class LiveMapModule {}
